// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'  

import echarts from 'echarts'
Vue.prototype.$echarts = echarts;
  
import router from './router'

/* eslint-disable no-new */
new Vue({
  el: '#app', 
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js